export default __webpack_public_path__ + "static/media/Welding.c72ed6ec.jpeg";